module.exports = __webpack_public_path__ + "img/npi-search.50b1081f.svg";